import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import "./AddJob.css";

const AddJobs = () => {
  const [title, setTitle] = useState(""); // State for title
  const [content, setContent] = useState(""); // State for content

  const handlePostJob = async () => {
    try {
      const jobData = { title, content, date: new Date() }; // Include title
      const response = await axios.post(
        "https://mirai-server.vercel.app/api/jobs",
        jobData
      );
      if (response.data.success) {
        alert("Job posted successfully!");
        setTitle(""); // Reset title
        setContent(""); // Reset content
      }
    } catch (error) {
      console.error(error);
      alert("Failed to post job.");
    }
  };

  return (
    <div>
      <div className="w-full py-6 border-b border-gray-300 px-6">
        <h1 className="text-2xl font-bold text-gray-700 font-roboto">
          Add Jobs
        </h1>
      </div>
      <div className="w-[600px] mx-auto my-10">
        {/* Input for job title */}
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter job title"
          className="w-full mb-4 p-2 border rounded"
        />
        {/* ReactQuill for job content */}
        <ReactQuill
          value={content}
          onChange={setContent}
          placeholder="Write your job post here..."
          className="custom-editor"
        />
        <button onClick={handlePostJob} className="mt-4 rounded-2xl font-roboto text-xl px-4 py-2 bg-blue-500 text-white">
          Post Job
        </button>
      </div>
    </div>
  );
};

export default AddJobs;
